import { CheckboxLabel, StyledLabel } from "./styles";

interface CheckBoxProps {
  className?: string | null;
  disabled?: boolean | "false" | "true";
  label?: string | React.ReactNode;
  name: string;
  id?: string | null;
  error?: boolean;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
  value: boolean | "false" | "true";
  "data-testid"?: string;
}

const isChecked = (checkValue: boolean | "false" | "true") =>
  checkValue === true || checkValue === "true";

const CheckBox: React.FC<CheckBoxProps> = ({
  className,
  disabled,
  id,
  label,
  name,
  onChange,
  onFocus,
  onBlur,
  value,
  error
}) => {
  return (
    <CheckboxLabel
      htmlFor={id || undefined}
      error={error}
      disabled={Boolean(disabled)}
      isChecked={isChecked(value)}
    >
      <input
        className={className || undefined}
        checked={isChecked(value)}
        disabled={Boolean(disabled)}
        id={id || undefined}
        name={name}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        type="checkbox"
        value={String(isChecked(value))}
      />
      <span>
        <StyledLabel error={error}>{label}</StyledLabel>
      </span>
    </CheckboxLabel>
  );
};

export default CheckBox;
